import { useState } from 'react'
import { Outlet, useLocation, Link } from 'react-router-dom'
import { AlertTriangle, X } from 'lucide-react'
import Sidebar from './Sidebar'
import TopNav from './TopNav'
import { useAuth } from '../../hooks/useAuth'

const pageTitles = {
  '/': 'Dynamic Pricing Engine Dashboard',
  '/dashboard': 'Dynamic Pricing Engine Dashboard',
  '/demo': 'Servicehive Revenue Optimization Platform',
  '/analytics': 'Advanced Analysis and Model Insights',
  '/customers': 'Market and Competitor Analysis',
  '/conversion': 'Pricing Review',
  '/performance': 'System Performance & Health Dashboard',
  '/settings': 'Settings Control',
  '/support': 'Support and Feedback',
  '/subscription': 'Subscription And Token Management',
  '/reporting': 'Advance Reporting',
}

// Token warning threshold
const LOW_TOKEN_THRESHOLD = 5000

export default function Layout() {
  const location = useLocation()
  const { user } = useAuth()
  const title = pageTitles[location.pathname] || 'Dashboard'
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)
  const [dismissedWarning, setDismissedWarning] = useState(false)

  // Get token balance from user (from API)
  const tokenBalance = user?.token_balance || 0
  const showLowTokenWarning = tokenBalance < LOW_TOKEN_THRESHOLD && !dismissedWarning

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 transition-colors duration-300">
      <Sidebar collapsed={sidebarCollapsed} onToggle={() => setSidebarCollapsed(!sidebarCollapsed)} />
      <div className={`transition-all duration-300 ${sidebarCollapsed ? 'ml-20' : 'ml-64'}`}>
        <TopNav title={title} />

        {/* Low Token Warning Banner */}
        {showLowTokenWarning && (
          <div className="mx-6 mt-4 p-4 bg-yellow-50 dark:bg-yellow-900/30 border border-yellow-200 dark:border-yellow-800 rounded-xl flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-yellow-100 dark:bg-yellow-900/50 rounded-lg">
                <AlertTriangle className="w-5 h-5 text-yellow-600 dark:text-yellow-400" />
              </div>
              <div>
                <p className="font-medium text-yellow-800 dark:text-yellow-200">
                  Low Token Balance
                </p>
                <p className="text-sm text-yellow-700 dark:text-yellow-300">
                  You have only <strong>{tokenBalance.toLocaleString()}</strong> tokens remaining.
                  Top up now to avoid service interruption.
                </p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <Link
                to="/subscription"
                className="px-4 py-2 bg-yellow-600 hover:bg-yellow-700 text-white text-sm font-medium rounded-lg transition-colors"
              >
                Buy Tokens
              </Link>
              <button
                onClick={() => setDismissedWarning(true)}
                className="p-1 text-yellow-600 hover:text-yellow-800 dark:text-yellow-400 dark:hover:text-yellow-200"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
          </div>
        )}

        <main className="p-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
}

